import React from "react";
import Tip from "../../utility/tip";
import Employee from "../../../../models/employee";
import QuestionBox from "../../utility/question-box";
import MessageBox from "../../utility/message-box";
import AutoComplete from "../../utility/auto-complete";
import rq from "../../utility/rq.js";


export default class CreateEmployee extends React.Component {

    constructor() {
        super();
        this.state = {
            propError: {},
            employeeData: false,
            loader: false
        };
        this.employee = new Employee({});
        this.questionBox = null;
        this.messageBox = null;
        this.onCreated = this.onCreated.bind(this);
        this.onFailed = this.onFailed.bind(this);
    }

    validate(propToCheck, model, value) {
        this[model][propToCheck] = value;
        var propError = Object.assign({}, this.state.propError);
        if (this[model].getErrors()[propToCheck]) {
            propError[propToCheck] = true;
        } else {
            delete propError[propToCheck];
        }
        // this.setState({propError});
        return propError;
    }

    handleKeyUp(propToCheck, model, e) {
        let propError = this.validate(propToCheck, model, e.target.value);
        this.setState({ propError });
    }

    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = (<QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>);
        this.forceUpdate();
    }
    editEmployee() {
        let propError = Object.assign({}, this.employee.getErrors());
        if (!this.employee.hasError() && this.refs.comment.value) {
            propError.commment = false;
            this.setState({ propError });
            this.askQuestion(`Do you want to Edit employee ${this.employee.employeeName} ?`, () => {
                rq.putJson("/api/v1/employee", { employeeData: this.employee, comment: this.refs.comment.value }).then(() => {
                    this.onCreated("Employee Update successfully");
                }).catch((err) => {
                    throw err;
                });
                this.questionBox = null;
                this.forceUpdate();
            }, () => {
                this.questionBox = null;
                this.forceUpdate();
            });
        } else {
            propError.commment = true;
            this.setState({ propError });
        }
    }

    onCreated(msg) {
        this.messageBox = MessageBox.showMessage(msg, true, this);
        this.searchBox.value = "";
        this.refs.contactNo.value = "";
        this.refs.address.value = "";
        this.employee = new Employee({});
        this.searchBox.focus();
        this.setState({ employeeData: false });
    }
    onFailed(msg) {
        this.messageBox = MessageBox.showMessage(msg, false, this);
        this.forceUpdate();
    }



    onEmployeeSelect(employee) {
        if (this.searchBox.value)
            this.setState({ loader: true });
        else
            this.setState({ loader: false });

        if (employee) {
            this.selectedEmployee = employee;
            let propError = Object.assign({}, this.state.propError);
            propError.employeeName = false;
            this.setState({ propError, loader: true });

            rq.getJsonData("/api/v1/employee/" + employee.employeeId).then((data) => {
                this.employee = new Employee(data[0]);
                this.setState({ propError, loader: false, employeeData: true });
            }).catch((err) => {
                throw err;
            });
        } else {
            this.employee = new Employee({});
            this.setState({ employeeData: false });
        }
    }
    componentDidMount() {
        this.searchBox.focus();
    }
    render() {
        return (
            <div className="smallholder">
                {this.questionBox}
                {this.messageBox}
                <p className="formMsg">Edit Employee</p>
                <table className="formTable">
                    <tbody>
                        <tr>
                            <td>
                                <p className="label">Select a Employee</p>
                                <Tip
                                    showOn={this.state.propError.employeeName}
                                    pointerStyle={{}}
                                    msg={"Please select employees Name"}
                                />


                                <AutoComplete
                                    placeholder="select an employee"
                                    dataSrc="/api/v1/employee/auto"
                                    dataTobind="employeeName"
                                    keyToBind="employeeId"
                                    tabIndex="1"
                                    onSelect={this.onEmployeeSelect.bind(this)}
                                    rex={(searchBox) => {
                                        this.searchBox = searchBox;
                                        //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);

                                    }}

                                />
                            </td>
                        </tr>

                    </tbody>
                </table>
                {this.state.loader ? <div style={{ fontSize: "20px", position: "absolute", top: "65%", left: "40%" }}>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </div> : null}
                {this.state.employeeData ? <div>
                    <table className="formTable">
                        <tbody>
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.contactNo}
                                        pointerStyle={{}}
                                        msg={this.employee.getErrors().contactNo}
                                    />
                                    <p className="label">Contact Number</p>
                                    <input
                                        tabIndex="2"
                                        type="number"
                                        className="formControl inputBox"
                                        placeholder="Contact Number"
                                        onBlur={this.handleKeyUp.bind(this, "contactNo", "employee")}
                                        onKeyUp={this.handleKeyUp.bind(this, "contactNo", "employee")}
                                        ref="contactNo"
                                        defaultValue={this.employee.contactNo}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.address}
                                        pointerStyle={{}}
                                        msg={this.employee.getErrors().address}
                                    />
                                    <p className="label">Empoyee address</p>
                                    <textarea
                                        rows="3"
                                        cols="38"
                                        tabIndex="3"
                                        type="text"
                                        className="formControl"
                                        placeholder="Empoyee address"
                                        onBlur={this.handleKeyUp.bind(this, "address", "employee")}
                                        onKeyUp={this.handleKeyUp.bind(this, "address", "employee")}
                                        ref="address"
                                        defaultValue={this.employee.address}
                                    >
                                    </textarea>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.commment}
                                        msg={"Why you want to Edit"}
                                    />
                                    <p className="label">Why you want to Edit</p>
                                    <textarea
                                        rows="4"
                                        cols="38"
                                        tabIndex="4"
                                        type="text"
                                        className="formControl "
                                        placeholder="comment"
                                        ref="comment"
                                    >
                                    </textarea>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                    : null}


                <button tabIndex="5" className="btn btnOk btnRight" onClick={this.editEmployee.bind(this)}>Edit Employee</button>
                <div className="clear"></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/edit/employee-edit.jsx